export const H6Fields = [
    { identifier: 'font-size-h6', type: 'input', field: 'font-size-h6' },
    { identifier: 'font-weight-h6', type: 'input', field: 'font-weight-h6' },
    { identifier: 'font-color-h6', type: 'input', field: 'font-color-h6' }
]
